import { render } from "./AttendanceDetails.vue?vue&type=template&id=5fe3a8dc"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js"

import "./AttendanceDetails.vue?vue&type=style&index=0&id=5fe3a8dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__